import { createSlice } from '@reduxjs/toolkit';
import produce from 'immer';
import { deserializeElement, getInnerText } from '../common/utilities';
import logger from '../common/logger';
import { triggerNotificationImpression } from '../common/analyticsApi';

export const messagingSlice = createSlice({
  name: 'messagingData',
  initialState: {
    messages: [],
  },
  reducers: {
    sendMessage: (state, action) => {
      const childrenText = getInnerText(deserializeElement(action?.payload?.children));
      triggerNotificationImpression({ notificationType: action?.payload?.type, notificationReason: childrenText });

      const newState = produce(state, (draftState) => {
        logger.info(`Toast ${action?.payload?.type} sent: ${childrenText}`);
        draftState.messages.push({ ...action.payload, id: new Date().getTime() });
        if (draftState.messages.length > 2) {
          draftState.messages = draftState.messages.slice(-2);
        }
      });
      return newState;
    },
    clearMessage: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.messages = draftState.messages.filter((message) => message.id !== action.payload);
      });
      return newState;
    },

  },

});

export const {
  sendMessage, clearMessage,
} = messagingSlice.actions;

export const getMessages = (state) => state.messagingData.messages;

export default messagingSlice.reducer;
